const ensureDate = (value: Date | string | number | null | undefined): Date | null | undefined => {
  if (value === null || typeof value === 'undefined') {
    return value as null;
  }

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return undefined;
    }
    return value;
  }

  try {
    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return undefined;
    }

    return date;
  } catch (e) {
    return undefined;
  }
};

export default ensureDate;
